import { render, staticRenderFns } from "./PrintInvoice.vue?vue&type=template&id=b3165ec4&"
import script from "./PrintInvoice.vue?vue&type=script&lang=js&"
export * from "./PrintInvoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PrintInvoice.vue"
export default component.exports